import React, { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { getPermission} from "../../../Conexiones/Conexion";
//import { GoKey } from "react-icons/go";
import '../../../CSS/checkbox.css'
import { Button, CloseButton, Col, Container, Modal, Row } from 'react-bootstrap';
import Select from 'react-select';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function Usuarios() {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUser = usuario[0].idUsuario;
    const [user,setUser]=useState();
    const uri = 'usuarios/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect (()=>{
        const getUsuarios = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUser,3);
            if(permiso){
                const endpoint = 'getAllUsuarios/';
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setUsuarios(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getUsuarios();
    },[idUser,navigate]);

    const getUsuarios = async () =>{
        const endpoint = 'getAllUsuarios/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setUsuarios(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }

    const [empleados,setEmpleados]=useState([])
    const [roles,setRoles] = useState([])
    const [idEmp,setIdEmp]=useState("")
    const [idRol,setIdRol] = useState('')
    const [correo, setCorreo] = useState('')
    const [codigo, setCodigo] = useState('')
    const [isSaving, setSaving] = useState(false);

    const getEmpleadosRoles = async () => {
        const endpoint = 'empleadosroles/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setEmpleados(res.data[0].empleados);
                setRoles(res.data[0].roles);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    //ELIMINAR USUARIO INICIO
    const modalDelete = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTA USUARIO?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡REGISTRO ELIMINADO CORRECTAMENTE!"){
                        getUsuarios();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }
    //ELIMINAR USUARIO FIN

    //AGREGAR USUARIO INICIO
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const showAdd = async () => {
        await getEmpleadosRoles();
        handleShow();
    }
    const closeAdd = () =>{
        handleClose()
        setIdEmp('')
        setIdRol('')
        setCodigo('')
        setCorreo('')
    }
    const handleSelectEmp = (e) =>{
        setIdEmp(e.value)
        setCodigo(e.codgo)
        setCorreo(e.correo)
    }
    const selectRol = (e) => {
        setIdRol(e.value)
    }
    const store = async (e) =>{
        setSaving(true);
        e.preventDefault()
        if( idEmp === '' || idRol === ''){
            warningToast('CAMPOS VACIOS','RELLENE TODOS LOS CAMPOS');
        }else{
            const endpoint = uri;
            const data = {idEmpleado:idEmp, idRol:idRol};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡USUARIO CREADO CORRECTAMENTE!"){
                    closeAdd();
                    getUsuarios();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
    //AGREGAR USUARIO FIN

    //EDITAR CLAVE INICIO
    const [nuevaClave, setNuevaClave] = useState();
    const [repetirClave, setRepetirClave] = useState();
    const [adminClave, setAdminClave] = useState();
    const [showClave, setShowClave] = useState(false);
    const handleCloseClave = () => setShowClave(false);
    const handleShowClave = (idUserClave) =>{
        setShowClave(true);
        setUser(idUserClave)
    }
    const cambiarClave = async (e) =>{
        e.preventDefault()
        const endpoint = 'usuarios-change/' + user;
        const data = {nuevaClave:nuevaClave,repetirClave:repetirClave,adminClave:adminClave, idAdmin:idUser};
        const res = await putApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="LA CONTRASEÑA HA SIDO ACTUALIZADA CORRECTAMENTE"){
                handleCloseClave();
                getUsuarios();
                successToast("EDITADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    //EDITAR CLAVE FIN

    //EDITAR ESTADO INICIO
    const editarEstado = (id) => {
        warningModal('¿QUIERES CAMBIAR EL ESTADO DEL USUARIO?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = 'updateEstado/' + id;
                const data = {};
                const res = await putApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        getUsuarios();
                        successToast("ESTADO EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }
    //EDITAR ESTADO FIN

    const getRoles = async () =>{
        const endpoint = 'roles/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setRoles(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    //EDITAR ROL INICIO
    const [rolId,setidRol]=useState()
    const [rolNombre,setRolNombre]=useState()
    const [showRol, setShowRol] = useState(false);
    const handleCloseRol = () => setShowRol(false);
    const handleShowRol = async (idUserRol,nombreRol,idRol) =>{
        await getRoles();
        setUser(idUserRol)
        setidRol(idRol)
        setRolNombre(nombreRol)
        setShowRol(true);
    }     
    const handleSelectChange = (event) =>{
        setidRol(event.value)
    }
    const valorId=  rolId
    const etiqueta = rolNombre

    const editarRol = async (e) =>{
        e.preventDefault()
        const endpoint = 'updateRol/' + user;
        const data = {idRol:rolId};
        const res = await putApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="ROL MODIFICADO"){
                handleCloseRol();
                getUsuarios();
                successToast("EDITADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        } 
    }
    //EDITAR ROL FIN


    //EDITAR PERMISOS INICIO
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {
        setShowEdit(false)
        getPermisos(user);
        getCatalogos(user)
    }
    const [listPermisos,setListPermisos]=useState([])
    const [checked] = useState(true);
    const getPermisos = async (id) =>{
        const endpoint = 'getCatalogoPermisos/'+id;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setListPermisos(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    //check permisos
    const asignarPermiso = async (idModulo,asignar,modulo) =>{
        const modificarPermiso = listPermisos.map ((listPermisos) =>{
            if(listPermisos.idModulo === idModulo){
                if(asignar===1){
                    return {
                        ...listPermisos,
                        asignar:0
                    }
                }else{
                    return {
                        ...listPermisos,
                        asignar:1
                    }
                }
            }
            return listPermisos
        });
        setListPermisos(modificarPermiso)
        console.log(modificarPermiso)
    }
    const permisos = async (e) =>{
        e.preventDefault()
        const  arregloJson = JSON.stringify(listPermisos)
        const  arregloCatalogo = JSON.stringify(catalogos)
        const endpoint = 'editarPermisos/' + user;
        const data = {listaPermisos:arregloJson,listaCatalogo:arregloCatalogo,};
        const res = await putApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="¡PERMISOS ASIGNADOS CORRECTAMENTE!"){
                handleCloseEdit();
                successToast("EDITADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        /*await axios.put(URI + 'editarPermisos/'+user,{listaPermisos:arregloJson,listaCatalogo:arregloCatalogo,},{
            headers: {
                'Content-Type': 'application/json',
            }}).then(
                res => {              
                    //console.log(res)
                    if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                        console.log('error conexion')
                        Swal.fire(
                            'Falla en el servidor...',
                            'Intente más tarde',
                            'question'
                          )
                    }else{
                        if(res.data.message==="¡PERMISOS ASIGNADOS CORRECTAMENTE!"){
                            Swal.fire({
                                icon: 'success',
                                title: res.data.message,
                                position: 'top-end',
                                showConfirmButton: true,
                                target: document.getElementById('modal-permisos')
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    //window.location.reload();
                                    handleCloseEdit()
                                } 
                            })
                            
                        }else{
                            Swal.fire({
                                title: '¡ERROR!',
                                text: res.data.message,                 
                                icon: 'error',
                                confirmButtonColor: 'red',
                                allowOutsideClick: false,
                                confirmButtonText: 'ACEPTAR'
                            })
                        }
    
                    }
                }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }
            }
        )*/
    }  
    /*const handleShowEdit = (idUser) =>{
        setShowEdit(true);
        setUser(idUser);
        getPermisos(idUser);
    }*/
    //EDITAR PERMISOS FIN

    //EDITAR CATALOGOS INICIO
    const [catalogos,setCatalogos]=useState([])
    const [showCatalogo, setShowCatalogo] = useState(false);
    const handleCloseCatalogo = () =>{
        setShowCatalogo(false);
        getCatalogos(user)
        setShowEdit(true)
    }
    const getCatalogos = async (id) =>{
        const endpoint = 'catalogo/'+id;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setCatalogos(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    //check permisos
    const asignarCatalogo = async (idModulo,asignar) =>{
        const modificarCatalogo = catalogos.map ((listCatalogo) =>{
            if(listCatalogo.idModulo === idModulo){
                if(asignar===1){
                    return {
                        ...listCatalogo,
                        asignar:0
                    }
                }else{
                    return {
                        ...listCatalogo,
                        asignar:1
                    }
                }
            }
            return listCatalogo
        });
        setCatalogos(modificarCatalogo)
        console.log(modificarCatalogo)
    }
    const handleShowCatalogo = (idUser,modulo,asignar) =>{
        if(modulo==="Catalogos"){
            if(catalogos.length===0){
                getCatalogos(idUser)
                mostrarTabla(modulo,asignar)
            }else{
                mostrarTabla(modulo,asignar)
            }
        }else if (modulo==="Proyectos"){
            console.log("proyectos")
            mostrarTabla(modulo,asignar)
        }else{
            mostrarTabla(modulo,asignar)
        }
    } 
    //Botón para administrar catalogos y proyectos
    const mostrarTabla = (modulo) => {
        if (modulo === "Catalogos") return document.getElementById("containerTabla").style.display="block";
        if (modulo === "Proyectos") return document.getElementById("containerTabla").style.display="block";
        if (modulo !== "Catalogos") return document.getElementById("containerTabla").style.display="none";
    };
    //BOTON ACEPTAR (MODAL CATALOGO), CERRAR VENTANA CATALOGO Y ABRIR PERMISOS
    const aceptar = () =>{
        setShowCatalogo(false);
        setShowEdit(true)
    }
    /*const navigatePermisos = (id) => {
        sessionStorage.setItem("userPermiso", id)
        navigate('/inicio/Catalogos/Usuarios/Permisos')
    }*/
    //EDITAR CATALOGOS FIN
    
    return (
        <div className="areas">
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">GESTIÓN DE USUARIOS</label>
                    </div>
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={showAdd} type="button">
                                <label className="agregar">USUARIO</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control"  style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>                    
                        </div>
                    </div>
                    {
                        usuarios.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" style={{marginTop:"20px"}} >
                            <div className="table tabla">
                                        <table className="table table-hover table-bordered ">
                                            <thead className="encabezado">
                                            <tr >                                
                                                <th>EMPLEADO</th>
                                                <th>CORREO</th>
                                                <th>ROL</th>
                                                <th>ESTADO</th>
                                                <th>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {usuarios.map(usuario =>{
                                                return(
                                                    usuario.idEmpleado === idUser ? (null):(
                                                        <tr key={usuario.idEmpleado}>                                       
                                                        <td valign="middle" className='text-uppercase'>{usuario.nombreEmp}{' '}{usuario.apellidoPaternoEmp}{' '}{usuario.apellidoMaternoEmp}</td>  
                                                        <td valign="middle">{usuario.correoEmp}</td>
                                                        <td valign="middle" className='text-uppercase'>{usuario.nombreRol}</td>
                                                        <td valign="middle">{usuario.estado === 1 ? ("ACTIVO"):("INACTIVO")}</td>
                                                        <td>
                                                            <div>
                                                            <div className="btn iconoH" style={{margin:'5px'}} onClick={() => handleShowClave(usuario.idEmpleado)} >
                                                                    <span className="bi bi-eye-slash-fill" title="CONTRASEÑA"></span>
                                                                </div>
                                                                <div className="btn iconoH" style={{margin:'5px'}} >
                                                                        <span className="bi bi-trash" title="ELIMINAR" onClick={() => modalDelete(usuario.idEmpleado)}></span>
                                                                </div>
                                                                <div className="btn iconoH" onClick={() => editarEstado(usuario.idEmpleado)}  style={{margin:'5px',fontSize:"25px"}} >
                                                                {usuario.estado === 1 ? (  <span className="bi bi-toggle2-on" title="ESTADO"></span> ):(<span className="bi bi-toggle2-off" title="ESTADO"></span> )}
                                                                </div>
                                                                <div className="btn iconoH"  onClick={() => handleShowRol(usuario.idEmpleado,usuario.nombreRol)} style={{margin:'5px'}}>
                                                                    <span className="bi bi-person-fill" title="EDITAR ROL"></span>
                                                                </div>
                                                                {/*<div className="btn iconoH"  onClick={() => navigatePermisos(usuario.idEmpleado)} style={{margin:'5px'}}>
                                                                    <span  title="PERMISOS"><GoKey/></span>
                                                                </div>*/} 
                                                            </div>
                                                        </td>
                                                    </tr>   
                                                    )
                                                                                                                        
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>      
                            </div>
                        )
                    }

                    {/*AGREGAR USUARIO*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-usuario">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR USUARIO</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeAdd} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label  className="text-uppercase" > Empleado <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        classNamePrefix="select"
                                        placeholder="Selecciona un empleado..."
                                        required
                                        options={empleados.map(e=>({label:e.nombreEmp+" "+e.apellidoPaternoEmp, value:e.idEmpleado,codgo:e.codigoEmp,correo:e.correoEmp}))}
                                        onChange={handleSelectEmp}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput2" className="form-label">CORREO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    {correo === codigo ? (
                                        <input type="text" className="form-control" disabled  required value={''}/>    
                                    ):(
                                        <input type="text" className="form-control" disabled  required value={correo}/>
                                    )}
                                    
                                </div>
                                <div className="mb-3">
                                    <label  className="text-uppercase" > ROLES <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        classNamePrefix="select"
                                        placeholder="Selecciona un rol..."
                                        required
                                        options={roles.map(r=>({label:r.nombreRol,value:r.idRol}))}
                                        onChange={selectRol}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeAdd}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR CLAVE*/}
                    <Modal  show={showClave}  onHide={handleCloseClave} id="modal-clave">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR CLAVE</Modal.Title>
                            <CloseButton onClick={handleCloseClave} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={cambiarClave}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">INGRESE LA CONTRASEÑA NUEVA DEL USUARIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="password" className="form-control" minLength={6}  required 
                                    onChange={e => setNuevaClave(e.target.value) }/>
                                </div> 
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput2" className="form-label">REPITA LA NUEVA CONTRASEÑA DEL USUARIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="password" className="form-control"   required 
                                    onChange={e => setRepetirClave(e.target.value) } minLength={6}/>
                                </div> 
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput3" className="form-label">INGRESE LA CONTRASEÑA DEL <label style={{color:'#a30000', fontWeight:'bold'}}>ADMINISTRADOR</label> <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="password" className="form-control"   required 
                                    onChange={e => setAdminClave(e.target.value) } />
                                </div>     
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseClave}>CANCELAR</Button>                                               
                                <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                     
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR ROL*/}
                    <Modal  show={showRol}  onHide={handleCloseRol} id="modal-rol">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR ROL</Modal.Title>
                            <CloseButton onClick={handleCloseRol} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={editarRol}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > rol <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        defaultValue={{ label: etiqueta, value: valorId }}
                                        required
                                        options={roles.map(tip=>({label:tip.nombreRol,value:tip.idRol}))}
                                        onChange={handleSelectChange}
                                    />
                                </div>   
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseRol}>CANCELAR</Button>                                               
                                <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                     
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR PERMISOS*/}
                    <Modal show={showEdit}  fullscreen='xxl-down' onHide={handleCloseEdit}  id="modal-permisos">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>ASIGNAR PERMISOS</Modal.Title>
                                <CloseButton onClick={handleCloseEdit} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={permisos}>
                            <Modal.Body  >
                                <Container fluid>
                                    <Row style={{height:"470px"}}>
                                        <Col xs={12} md={6} >
                                            {
                                                listPermisos.length === 0 ? (<h3>AUN NO HAY REGISTROS</h3>):(
                                                    <div >
                                                        <div >
                                                            <table className="table  text-uppercase" style={{textAlign:"center"}}>
                                                                <thead  className="table-primary">
                                                                    <tr>
                                                                        <th > MODULO </th>
                                                                        <th >ASIGNAR</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody >
                                                                {listPermisos.map( catalogo => {
                                                                    return (
                                                                        <tr key={catalogo.idModulo}>
                                                                            <td onClick={() => handleShowCatalogo(user,catalogo.nomModulo,catalogo.asignar)} >{catalogo.nomModulo}</td>
                                                                            <td>
                                                                                    <label className="switch">
                                                                                        <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                        onClick={()=>asignarPermiso(catalogo.idModulo,catalogo.asignar,catalogo.nomModulo)} />
                                                                                        <span className="slider round"></span>
                                                                                    </label>
                                                                            </td>
                                                                            {/*<td>
                                                                                    <div className="btn iconoH"  onClick={() => handleShowCatalogo(user,catalogo.nomModulo)}  style={{display:mostrarIcono(catalogo.nomModulo,catalogo.asignar)}}>
                                                                                        <span><BsFillPlusCircleFill/></span>
                                                                                    </div> 
                                                                            </td>*/}
                                                                        </tr>
                                                                    )})
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <div style={{textAlign:"center",display:"none"}} id="containerTabla" >
                                                <table  className="table  text-uppercase" >
                                                    <thead  className="table-primary">
                                                        <tr>
                                                            <th > permiso </th>
                                                            <th >ASIGNAR</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                    {catalogos.map( catalogo => {
                                                        return (
                                                            <tr key={catalogo.idModulo}>
                                                                <td >{catalogo.nomModulo}</td>
                                                                        <td>
                                                                            <label className="switch">
                                                                                <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                onClick={()=>asignarCatalogo(catalogo.idModulo,catalogo.asignar)} />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                        </td>
                                                                </tr>
                                                        )})
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                     
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*ASIGNAR CATALOGOS*/}
                    <Modal  show={showCatalogo} onHide={handleCloseCatalogo} id="modal-catalogo">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>ADMINISTRAR CATALOGO</Modal.Title>
                            <CloseButton  onClick={handleCloseCatalogo} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body >
                            { catalogos.length === 0 ? (<h3>AUN NO HAY REGISTROS</h3>):(
                                <div >
                                    <div>
                                        <table className="table  text-uppercase" style={{textAlign:"center"}}>
                                            <thead  className="table-primary">
                                                <tr>
                                                    <th > permiso </th>
                                                    <th >ASIGNAR</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                            {catalogos.map( catalogo => {
                                                return (
                                                    <tr key={catalogo.idModulo}>
                                                        <td >{catalogo.nomModulo}</td>
                                                        <td>
                                                            <label className="switch">
                                                                <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                onClick={()=>asignarCatalogo(catalogo.idModulo,catalogo.asignar)} />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </td>
                                                    </tr>
                                                )})
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary" onClick={handleCloseCatalogo}>CANCELAR</Button>                                               
                            <Button  className="btn btn-light btncolor" onClick={aceptar} >ACEPTAR</Button>                                                     
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default Usuarios;